import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslate } from 'hooks/useTranslate';

import { State } from 'redux/initialState';

import Button from 'modules/_shared/components/Buttons';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';
import { setModal } from 'modules/_shared/redux/modalActions';
import SignatureModal from 'modules/documents/pages/Documents/SignaturesModal';

type EnvelopesListHeaderProps = {
  envelopesTotal: number;
  onRefresh?: () => void;
};

const EnvelopesListHeader: FC<EnvelopesListHeaderProps> = ({
  envelopesTotal,
  onRefresh,
}) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const isAdmin = useSelector((state: State) => state.society?.role?.isAdmin);
  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );

  const getEnvelopesDescription = () =>
    `${actualSociety?.name || t('Society')} ${t('HaveEnvelopes', {
      count: envelopesTotal,
    })}`;

  const handleAddEnvelope = () => {
    dispatch(setModal(<SignatureModal onSent={onRefresh} />));
  };

  const actions = [];

  if (onRefresh) {
    actions.push(
      <Button key="refresh" onClick={onRefresh} variant="light">
        <em className="icon ni ni-update mr-1" />
        {t('Refresh')}
      </Button>
    );
  }

  if (isAdmin) {
    actions.push(
      <Button key="add" onClick={handleAddEnvelope} variant="primary">
        <em className="icon ni ni-plus mr-1" />
        {t('NewSignature')}
      </Button>
    );
  }

  return (
    <PageListHeader
      subTitle={t('Signatures')}
      description={getEnvelopesDescription()}
      actions={actions}
    />
  );
};

export default EnvelopesListHeader;
